export default __webpack_public_path__ + "static/media/equipment_preview.f4ab5d3f.png";